import { render, staticRenderFns } from "./CustomCheckboxOn.vue?vue&type=template&id=440eac10&"
import script from "./CustomCheckboxOn.vue?vue&type=script&lang=ts&"
export * from "./CustomCheckboxOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports